// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DKS9","comment":"styles_comment__2sFI6"};